import { render, staticRenderFns } from "./HdForm.vue?vue&type=template&id=bc737118&scoped=true"
import script from "./HdForm.vue?vue&type=script&lang=js"
export * from "./HdForm.vue?vue&type=script&lang=js"
import style0 from "./HdForm.vue?vue&type=style&index=0&id=bc737118&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc737118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc737118')) {
      api.createRecord('bc737118', component.options)
    } else {
      api.reload('bc737118', component.options)
    }
    module.hot.accept("./HdForm.vue?vue&type=template&id=bc737118&scoped=true", function () {
      api.rerender('bc737118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/HdForm.vue"
export default component.exports